"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePasswordFormFields = exports.changePasswordSchema = exports.emailFormFields = exports.emailSchema = void 0;
const zod_1 = require("zod");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const regexp_1 = require("@Const/regexp");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const usernameKey = 'username';
const codeKey = 'code';
const passwordKey = 'password';
const password2Key = 'password2';
const emailSchema = zod_1.z.object({
    [usernameKey]: zod_1.z
        .string({
        required_error: 'Fill in the required field',
    })
        .email()
        .max(255),
});
exports.emailSchema = emailSchema;
const emailFormFieldsNoSchema = {
    [usernameKey]: {
        name: usernameKey,
        label: 'Email',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
};
const emailFormFields = (0, populate_schema_1.default)(emailFormFieldsNoSchema, emailSchema);
exports.emailFormFields = emailFormFields;
const passwordErrorMessage = 'Minimum 10 characters and at least one upper case, one lower case, one number and one special character';
const changePasswordSchema = zod_1.z
    .object({
    [codeKey]: zod_1.z.string({
        required_error: passwordErrorMessage,
    }),
    [passwordKey]: zod_1.z.string({
        required_error: passwordErrorMessage,
    }),
    [password2Key]: zod_1.z.string({
        required_error: passwordErrorMessage,
    }),
})
    .superRefine((changePassword, ctx) => {
    if (changePassword.password) {
        if (!regexp_1.PASSWORD_REGEX.test(changePassword.password)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: passwordErrorMessage,
                path: [passwordKey],
            });
        }
        if (changePassword.password2 !== changePassword.password) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'Passwords must match',
                path: [password2Key],
            });
        }
    }
    else {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
        });
    }
    if (!changePassword.code) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
        });
    }
});
exports.changePasswordSchema = changePasswordSchema;
const changePasswordFormFieldsNoSchema = {
    [codeKey]: {
        name: codeKey,
        label: 'Code',
        type: form_field_types_1.FormFieldTypes.TEXT,
        tooltip: (react_1.default.createElement(CustomToolTip_1.default, { type: '?', place: 'right', info: 'A password reset code has been sent to your ' +
                'email address associated with the account. If ' +
                "you're still experiencing issues, contact us for " +
                'assistance.' })),
    },
    [passwordKey]: {
        name: passwordKey,
        label: 'Enter a new password',
        type: form_field_types_1.FormFieldTypes.TEXT,
        inputType: 'password',
        tooltip: (react_1.default.createElement(CustomToolTip_1.default, { type: '?', place: 'right', info: 'Passwords must contain at least 10 characters ' +
                'with at least one upper case, one lower case, one ' +
                'number and one special character.' })),
    },
    [password2Key]: {
        name: password2Key,
        label: 'Repeat the password',
        type: form_field_types_1.FormFieldTypes.TEXT,
        inputType: 'password',
    },
};
const changePasswordFormFields = (0, populate_schema_1.default)(changePasswordFormFieldsNoSchema, changePasswordSchema);
exports.changePasswordFormFields = changePasswordFormFields;
